export default {
    methods: {
        declensionOfNum(number, titles) {
            const cases = [2, 0, 1, 1, 1, 2];
            const condition = number % 100 > 4 && number % 100 < 20;
            return titles[condition ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
        },
    },
};
